import type { Chapter } from "@/config/chapters";
import { STATE_COPY } from "@/config/chapterCopy";

/** Chapter / Edition / Status metadata rows, in the product-page typography. */
export function ChapterStatus({ chapter }: { chapter: Chapter }) {
  const copy = STATE_COPY[chapter.state];
  return (
    <div className="mt-8 border-t border-border pt-6">
      <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 font-display text-xs uppercase tracking-[0.2em]">
        <dt className="text-muted-foreground">Chapter</dt>
        <dd className="text-parchment">{chapter.label}</dd>
        <dt className="text-muted-foreground">Edition</dt>
        <dd className="text-parchment">{chapter.edition}</dd>
        <dt className="text-muted-foreground">Status</dt>
        <dd className="text-gold">{copy.statusLabel}</dd>
      </dl>
    </div>
  );
}
